import { normalizeStage, type Stage } from '../settings'
import {
  getVideoModelMetadata,
  VIDEO_MODEL_METADATA,
  type VideoMode,
  type VideoModel,
  type VideoModelMetadata
} from './video-generation'

export { getVideoModelMetadata, VIDEO_MODEL_METADATA }
export type { VideoModelMetadata }

export type VideoModelPolicy = Readonly<Record<VideoMode, readonly VideoModel[]>>

/** Every model supported by Ale's personal development stage. */
export const ALE_MODELS: VideoModelPolicy = {
  text: [
    'gen4.5', //
    'veo3.1_fast',
    'seedance2_5',
    'gemini_omni_flash'
  ],
  frames: [
    'gen4.5', //
    'veo3.1_fast',
    'seedance2_5',
    'gemini_omni_flash'
  ],
  references: ['seedance2_5', 'gemini_omni_flash'],
  edit: ['seedance2_5', 'gemini_omni_flash'],
  extend: ['seedance2_5', 'gemini_omni_flash']
}

/** Development uses Ale's full model policy. */
export const DEV_MODELS = ALE_MODELS

/** Personal local stages use Ale's full model policy. */
export const LOCAL_DEV_MODELS = ALE_MODELS

/** The default policy for stages without a dedicated catalog. */
export const GENERIC_MODELS = LOCAL_DEV_MODELS

export const VIDEO_MODEL_MANIFEST: Readonly<Record<Stage, VideoModelPolicy>> = {
  local: LOCAL_DEV_MODELS,
  dev: DEV_MODELS,
  stg: GENERIC_MODELS,
  prd: GENERIC_MODELS
}

export function getVideoModelPolicyForStage(stage: string): VideoModelPolicy {
  const normalizedStage = stage.trim().toLowerCase()
  return normalizedStage === 'ale' ? ALE_MODELS : VIDEO_MODEL_MANIFEST[normalizeStage(normalizedStage)]
}

export function isVideoModelAllowed(stage: string, mode: VideoMode, model: VideoModel): boolean {
  return getVideoModelPolicyForStage(stage)[mode].includes(model)
}
